import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-strong-right--sprite",
  "use": "arrow-strong-right--sprite-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 32 32\" id=\"arrow-strong-right--sprite\">\n    <defs>\n        <path id=\"arrow-strong-right--sprite_a\" d=\"M10.998 8.586L2.162 17 .18 14.94l6.853-6.526L0 2.06 2.164 0 11 8.586z\" />\n    </defs>\n    <use fill-rule=\"evenodd\" transform=\"translate(11 8)\" xlink:href=\"#arrow-strong-right--sprite_a\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol